import { StrictMode } from 'react';

import { EnvProvider } from '@zenbusiness/application-commons-env';
import { BrowserRouter as Router } from 'react-router-dom';

import ClickstreamWrapper from '#client/ClickstreamWrapper';
import { USE_STRICTMODE } from '#client/manifest';
import Providers from '#client/Providers';
import Routing from '#client/routes';

function StrictishMode({ children }) {
  if (USE_STRICTMODE) {
    return <StrictMode>{children}</StrictMode>;
  }
  return children;
}

export function LocalAppInit() {
  const LOCAL_ENV = {
    ...process.env.BUILD_ENV,
    ...window.ENV
  };
  return (
    <StrictishMode>
      <EnvProvider env={LOCAL_ENV}>
        <Router>
          <Providers>
            <ClickstreamWrapper>
              <Routing />
            </ClickstreamWrapper>
          </Providers>
        </Router>
      </EnvProvider>
    </StrictishMode>
  );
}

export default LocalAppInit;
